import React, { useEffect, useState } from 'react';
import { BookIcon, ClockIcon, CheckIcon } from 'lucide-react';
import { MOCK_PROGRAM_DATA, ScheduleItem, getActivityLabel, getSubjectGradient } from '../utils/programData';
import { BookOpenIcon, PenLineIcon, VideoIcon, FileTextIcon } from 'lucide-react';
export function BugunYapilacaklar() {
  const [todaySchedule, setTodaySchedule] = useState<ScheduleItem[]>([]);
  // Get today's day name in Turkish
  const today = new Date().toLocaleString('tr-TR', {
    weekday: 'long'
  });
  // Use the shared data source
  useEffect(() => {
    const todayItems = MOCK_PROGRAM_DATA[today] || [];
    setTodaySchedule(todayItems);
  }, [today]);
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'study':
        return BookOpenIcon;
      case 'practice':
        return PenLineIcon;
      case 'exam':
        return FileTextIcon;
      case 'video':
        return VideoIcon;
      case 'homework':
        return FileTextIcon;
      default:
        return ClockIcon;
    }
  };
  // Helper function to get progress text based on activity type
  const getProgressText = (item: ScheduleItem) => {
    if (item.completed) {
      return 'Tamamlandı';
    }
    switch (item.activityType) {
      case 'video':
        return `İzleme durumu: %${item.progress || 0} tamamlandı`;
      case 'exam':
        return `Test durumu: ${item.progress || 0}/${item.totalQuestions || 100} soru çözüldü`;
      case 'homework':
        return `Ödev durumu: %${item.progress || 0} tamamlandı`;
      case 'study':
        return `İlerleme: %${item.progress || 0} tamamlandı`;
      case 'practice':
        return `Alıştırma: %${item.progress || 0} tamamlandı`;
      default:
        return `İlerleme: %${item.progress || 0}`;
    }
  };
  return <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-32">
      <div className="bg-black/90 rounded-lg p-6 relative overflow-hidden" data-id="element-33">
        <h3 className="text-gray-400 font-medium text-sm mb-4" data-id="element-34">
          Bugün Programda Ne Var?
        </h3>
        {todaySchedule.length === 0 ? <div className="text-center py-8 text-gray-400" data-id="element-35">
            Bugün için planlanmış aktivite bulunmuyor
          </div> : <div className="space-y-4" data-id="element-36">
            {todaySchedule.map(item => {
          const Icon = getActivityIcon(item.activityType);
          const gradientClass = getSubjectGradient(item.subject);
          // Kurum dersi (dolu renkli)
          if (item.isInstitutional) {
            return <div key={item.id} className={`p-4 rounded-lg bg-gradient-to-r ${gradientClass} ${item.completed ? 'opacity-60' : ''} group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300 relative overflow-hidden`} data-id="element-37">
                    <div className="flex items-center justify-between mb-2" data-id="element-38">
                      <h3 className="text-lg font-bold text-white" data-id="element-39">
                        {item.subject}
                      </h3>
                      <div className="flex items-center gap-2" data-id="element-40">
                        <span className="text-sm text-white/90 bg-black/20 px-2 py-1 rounded-full" data-id="element-41">
                          {item.startTime} - {item.endTime}
                        </span>
                        {item.completed && <CheckIcon className="w-5 h-5 text-white bg-green-500 rounded-full p-1" data-id="element-42" />}
                      </div>
                    </div>
                    <div className="flex items-center gap-2 text-white/90" data-id="element-43">
                      <Icon className="w-4 h-4" data-id="element-44" />
                      <span className="text-sm" data-id="element-45">Kurum Dersi</span>
                    </div>
                    {item.notes && <div className="mt-2 text-sm text-white/80 bg-black/20 p-2 rounded" data-id="element-46">
                        {item.notes}
                      </div>}
                    {/* Parlama efekti */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-47" />
                  </div>;
          }
          // Kişisel çalışma (kenarlık renkli)
          return <div key={item.id} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradientClass} ${item.completed ? 'opacity-60' : ''} group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300`} data-id="element-48">
                  <div className="bg-black/90 p-4 rounded-lg relative overflow-hidden" data-id="element-49">
                    <div className="flex items-center mb-3" data-id="element-50">
                      <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-3 ${item.completed ? 'bg-green-500 text-white' : 'bg-white/10'}`} data-id="element-51">
                        {item.completed && <CheckIcon className="w-4 h-4" data-id="element-52" />}
                      </div>
                      <div data-id="element-53">
                        <h3 className={`text-lg font-semibold ${item.completed ? 'line-through text-gray-400' : 'text-white'}`} data-id="element-54">
                          {item.subject}
                        </h3>
                      </div>
                    </div>
                    <div className="space-y-2" data-id="element-55">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-56">
                        <span className="text-gray-300 flex items-center gap-2" data-id="element-57">
                          <Icon className="w-4 h-4 text-blue-400" data-id="element-58" />
                          <span className="text-sm" data-id="element-59">
                            {getActivityLabel(item.activityType)}
                          </span>
                        </span>
                        <span className="text-xs text-gray-300 bg-white/5 px-2 py-1 rounded-full" data-id="element-60">
                          {item.startTime} - {item.endTime}
                        </span>
                      </div>
                      {item.notes && <div className="text-xs text-gray-400 bg-white/5 p-2 rounded" data-id="element-61">
                          <span className="text-blue-400 font-medium" data-id="element-62">
                            Not:{' '}
                          </span>
                          {item.notes}
                        </div>}
                      {/* İlerleme durumu bilgisi - buton yerine bilgi gösterimi */}
                      <div className="text-sm text-gray-400 bg-white/5 p-2 rounded mt-2" data-id="element-63">
                        {getProgressText(item)}
                      </div>
                      {/* Progress bar */}
                      {!item.completed && item.progress !== undefined && <div className="w-full bg-white/10 rounded-full h-2 mt-1" data-id="element-64">
                          <div className="bg-blue-500 h-2 rounded-full" style={{
                    width: `${item.progress}%`
                  }} data-id="element-65"></div>
                        </div>}
                    </div>
                    {/* Parlama efekti */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-66" />
                  </div>
                </div>;
        })}
          </div>}
        {/* Parlama efekti */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-67" />
      </div>
    </div>;
}